import React from 'react';
import { useNavigate } from 'react-router-dom';

import Card from './components/card';
import withPagination from '../../hoc/with-pagination';
import AngleRightIcon from '../../assets/angle-right-icon';
import { API, ROUTES } from '../../helpers/constants';
import useGroupingData from '../../hook/use-grouping-data';
import LoadingListItem from './components/loading-list-item';

const Tour = ({ data, onSearch, searchText }) => {
  const navigate = useNavigate();
  const groupingData = useGroupingData({
    data: data,
    groupBy: 'city_name'
  });

  return (
    <div className="mb-10">
      <div className="w-full md:w-[80%] m-auto pt-10">
        {groupingData?.map((city) => (
          <div className="flex-col mb-5" key={city?.title}>
            {!searchText && (
              <div className="flex flex-col justify-center md:justify-between items-center md:flex-row mb-4">
                <h2 className="text-left text-2xl">{city?.title}</h2>
                <button
                  onClick={() => onSearch(city?.title)}
                  type="button"
                  className="text-[#D3A925] bg-[#FFF5D5] inline-flex items-center gap-2 font-medium rounded-lg text-sm px-5 py-2.5 my-4 focus:outline-none"
                >
                  Lihat Selengkapnya
                  <AngleRightIcon />
                </button>
              </div>
            )}
            <div className="grid grid-cols-1 w-[85%] md:w-full mx-auto md:grid-cols-2 lg:grid-cols-3 gap-6">
              {city?.items?.map((item) => (
                <Card
                  key={item?.['city_id']}
                  name={item?.name}
                  sourceImage={item?.['file_url']}
                  onClick={() => navigate(`${ROUTES.tour}/${item?.id}`)}
                  location={item['city_name']}
                  capacity={item?.kapasitas}
                  facilities={item?.facility}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withPagination(Tour, {
  queryKey: 'tours',
  api: `${process.env.REACT_APP_API_BASE_URL}/${API.tours}?group=2`,
  pageNumberLimit: 8,
  header: {
    title: 'Kawasan Wisata Jawa Barat',
    subtitle: 'Dapatkan informasi wisata terdekat Kabupaten dan Kota Tujuan perjalanan anda.',
    button: {
      placeholder: 'Cari Kota/ Kabupaten Tujuan',
      id: 'search-tour'
    }
  },
  loading: {
    renderItem: <LoadingListItem />,
    colItem: {
      sm: 1,
      md: 2,
      lg: 3
    }
  }
});
